
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/graph/[id]",
      function () {
        return require("private-next-pages/graph/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/graph/[id]"])
      });
    }
  